<div class="error-message" *ngIf="message">
  {{ message }}
</div>
